import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy3 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    var pack = document.querySelector("#pp").value;
    var direct = document.querySelector("#direct").value;
    var level = document.querySelector("#level").value;
    var wid = document.querySelector("#wid").value;
    var i =0;
    const refer = document.querySelector("#hid").value;
    var a1 = document.querySelector("#tt2").value;
    console.log(name, contract);
    console.log(refer);
    var a = document.querySelector("#test").value;
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const addr = document.querySelector("#us").value;
    function refreshPage() {
      window.location.reload(false);
    }
    const addressOfYourContract = '0xaeea5eb9282e8a10ffa2d6d1a98210e141ff8ae9';
    const amountInTheSmallestUnit = ("000000000000000000");
  
    const busdContractAddress = '0x418e5662abD0dB9F67b43b0976B7B68b0a974978';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;
 
    
    console.log(addr);
    

    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
    /*
if(addr=="0x0b15F4dbb00ABc232fcA1a54aF1bdd829E7eb68E")
{

}
  else if(addr="0xC7CeFCD51616B42f447A208b6cf8331cd9754036") 
  {

  }
  else
  { 
    */
  console.log('hello');
  console.log(a);
  console.log(wid);
  console.log(direct);
  console.log(level);
 
  if(a > 0 && a < 101 && pack < 499)
           {
              i = 100 - wid;
            }

if(pack > 499 && pack < 1000 && direct > 1 && level > 3 && a < 251 && a >0)
{
           i=250-wid;
}
else if(pack > 499 && pack < 1000 && a < 101 && a >0)
{
             i=100-wid;
  
}

if(pack > 999 && pack < 5000 && direct > 5 && level > 14 && a < 501 && a >0)
{
    i=500-wid;        
}

else if(pack > 999 && pack < 5000 && direct > 1 && level > 3 && a < 251 && a >0)
{
  i=250-wid;
}
else if(pack > 999 && pack < 5000 && a < 101 && a >0)
{
              i=100-wid;
  
}
 
if(pack > 4999 && pack < 10000 && direct > 15 && level > 34 && a < 1001 && a > 0)
{
              i=1000-wid;
}
else if(pack > 4999 && pack < 10000 && direct > 5 && level > 14 && a < 501 && a > 0)
{
             i=500-wid;
}

else if(pack > 4999 && pack < 10000 && direct > 1 && level > 3 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 4999 && pack < 10000 && a < 101 && a >0)
{
              i=100-wid;
  
}

if(pack > 9999 && pack < 3000001 && direct > 18 && level > 49 && a < 1251 && a >0)
{
             i=1250-wid;
}

else if(pack > 9999 && pack < 30000 && direct > 15 && level > 34 && a < 1001 && a >0)
{
            i=1000-wid;
}
else if(pack > 9999 && pack < 30000 && direct > 5 && level > 14 && a < 501 && a > 0)
{
              i=500-wid;
}

else if(pack > 9999 && pack < 30000 && direct > 1 && level > 3 && a < 251 && a >0)
{
             i=250-wid;
}
else if(pack > 9999 && pack < 30000 && a < 101 && a >0)
{
                 i=100-wid;
  
}
  
if(i < a)
{

}
else
{
/*
      const transaction = await contract.withdraw(addr,a, {
          gasLimit: 900000,
      });
  
  
      await transaction.wait();
  */   
      console.log("Transaction is done");
}
  
/*
if(a>9)
 {
      const transaction = await contract.withdraw(addr,a, {
          gasLimit: 900000,
      });
  
  
      await transaction.wait();
     
      console.log("Transaction is done");
 }                                                                                      
*/                                                                                                                               
   
   refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
     
        <form onSubmit={buyChai}>
        
        
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <button
    type="submit"
    id="sample"
    className="btn btn-accent-icon"
   style={{ backgroundColor: "yellowgreen", color: "white" }}
  >
    Withdraw
  </button>
</div>

        </form>
      </div>
    </>
  );
};
export default Buy3;